import { render, staticRenderFns } from "./thumbnail-panel.vue?vue&type=template&id=0bbdcc26&scoped=true&"
import script from "./thumbnail-panel.vue?vue&type=script&lang=js&"
export * from "./thumbnail-panel.vue?vue&type=script&lang=js&"
import style0 from "./thumbnail-panel.vue?vue&type=style&index=0&id=0bbdcc26&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bbdcc26",
  null
  
)

export default component.exports